import React from "react"
import {Grid, Typography} from "@mui/material";
import CCOCard from "../../fundamentals/CCOCard";
import CCOTextOverlay from "../../fundamentals/CCOTextOverlay";
import {metaDataProperty} from "../../preview/previewMetaData";
import PreviewElementBoxDrawer from "../../preview/PreviewElementBoxDrawer";
import {usePreviewContext} from "../../../context/PreviewContext";
import {getAltText} from "../../fundamentals/CCOPicture";


interface Props {
    item: any,
    orientation: string,
    teaser?: boolean
    useSquareImage?: boolean
    customStyle?: any
    shouldUseResponsiveFontSize?: boolean
}

function C021KachelTeaserCard(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    const width = (props.orientation === 'portrait_ratio1x1' ? 890 : (props.orientation === 'portrait_ratio3x4') ? 780 : 2080)
    const imgWidth = props.useSquareImage ? 540 : width;
    const kachelTeaserCardFocusedStyle = {
        paddingX: '2px',
        '& a:focus-visible': {
            outlineOffset: 0,
            outline: '2px solid black',
        },
    }
    const bgImage = (props?.item?.teaserSettings?.color || !props.item?.picture?.data?.uri) ? {
        src: `/empty${imgWidth}.svg`,
        alt: getAltText(props.item?.picture?.alt, props.item?.picture?.title),
        color: props.item.teaserSettings?.color,
        width: imgWidth,
        isColor: true
    } : {
        src: `/media${props.item?.picture?.data?.uri}/${props.orientation}/${imgWidth}`,
        alt: getAltText(props.item?.picture?.alt, props.item?.picture?.title),
        width: imgWidth,
        isColor: false
    }
    const fontStyle = () => {
        if (props.shouldUseResponsiveFontSize) {
            return  {xs: '1.4rem', md: '1.125rem', lg: '1.4rem'};
        }
        return '1.4rem';
    }

    return <CCOCard item={props.item} noSize={!props.teaser}
                    customStyle={{...props.customStyle, ...kachelTeaserCardFocusedStyle}}>
        <React.Fragment>
            <CCOTextOverlay image={bgImage}
                            color={props.item.teaserSettings?.color ? props.item.teaserSettings?.color : 'green'}>
                <Grid container>
                    <Grid item sx={{mx: 6}}>
                        <PreviewElementBoxDrawer propertyId={props.item.id}>
                            {props.item?.teaserTitle ?
                                <Typography
                                    variant={'overline'}
                                    sx={{
                                        background: 'white',
                                        boxDecorationBreak: 'clone',
                                        py: '8px',
                                        px: '12px',
                                    }}
                                    {...metaDataProperty(isPreview, 'properties.teaserTitle', props.item.id)}
                                >{props.item?.teaserTitle}</Typography>
                                : null}
                            {props.item?.headline || props.item?.title ?
                                <Typography variant={'h3'}
                                            sx={{
                                                '& span': {
                                                    background: 'white',
                                                    py: {xs: '8px', lg: '10px'},
                                                    px: '12px',
                                                    fontSize: fontStyle(),
                                                    boxDecorationBreak: 'clone',
                                                    lineHeight: {xs: '160%', lg: '120%'}
                                                },
                                                mb: 0, mt: 5
                                            }}>
                                    <span {...metaDataProperty(isPreview, props.item?.headline ? 'properties.headline' : 'properties.title', props.item.id)}>{props.item?.headline || props.item?.title}</span></Typography>
                                : null}
                        </PreviewElementBoxDrawer>
                    </Grid>
                </Grid>
            </CCOTextOverlay>
        </React.Fragment>
    </CCOCard>
}

export default C021KachelTeaserCard